import { Typography } from 'antd';
import * as React from 'react';
import styled from 'styled-components';

const { Text, Title } = Typography;

const SubjectTitle = styled(Text)`
  display: block;
  margin-bottom: 0;
  &.ant-typography {
    margin-bottom: 0;
    font-size: ${props => props.theme.fontSizeHeading5}px;
    font-weight: 600;
    line-height: 1.33;
  }
`;

export interface ICommunicationSubjectProps {
  subject?: string | null;
}

/**
 * Oggetto della comunicazione
 */
export function CommunicationSubject(props: ICommunicationSubjectProps) {
  const { subject } = props;

  return <SubjectTitle>{subject}</SubjectTitle>;
}
